import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import { faOctagon, faCircle, faClock, faGaugeHigh } from '@fortawesome/free-solid-svg-icons'


export const StatusIcons=({status, size})=>{
            //console.log("HELPER: " + status);

    switch (status){
        case "OPEN":
            //console.log("HELPER OPEN");
            return(
                <span><FontAwesomeIcon icon={faCircle} style={{color:"#37b400", fontSize:{size}}}></FontAwesomeIcon></span>
            )
        case "CLOSED":
            //console.log("HELPER CLOSED");
            return(
                <span><FontAwesomeIcon icon={faOctagon} style={{color:"#f31700",fontSize:{size}}}></FontAwesomeIcon></span>
            )
        case "HOLD":
            //console.log("HELPER HOLD");
            return(
                <span><FontAwesomeIcon icon={faClock} style={{color:"#0058e9",fontSize:{size}}}></FontAwesomeIcon></span>
            )
        case "CAPACITY":
            //console.log("HELPER CAPACITY");
            return(
                <span><FontAwesomeIcon icon={faGaugeHigh} style={{color:"#ffc000",fontSize:{size}}}></FontAwesomeIcon></span>
            )
        default:
            return(
                <FontAwesomeIcon icon={faOctagon} style={{color:"pink",fontSize:{size}}}></FontAwesomeIcon>
            )
    }
}

export const IconCell = (props) => {
        //console.log(props.dataItem)
        const retVal = StatusIcons({status:props.dataItem.Status, size:"xx-large"});
        return (
            <td {...props.tdProps}>
                {retVal}
            </td>
        );
    };